import { DataSynchronizationApi } from "~/api/DataSynchronization"

export function useDataSynchronizationApi(): DataSynchronizationApi {
   const dataSynchronizationApi = new DataSynchronizationApi(useHttpClient())
   return dataSynchronizationApi
}
